import React from "react"
import { BarChart2, BookOpen, BrainCircuit, Sparkles } from "lucide-react"
import "./AssessorHeader.style.scss"

interface AssessorHeaderProps {
  total: number
  questionCount: number
  paperCount: number
}

const AssessorHeader = ({
  total,
  questionCount,
  paperCount,
}: AssessorHeaderProps) => (
  <header className="assessor-header">
    <div className="assessor-header__title-row">
      <div className="assessor-header__icon">
        <BrainCircuit size={24} />
      </div>
      <div>
        <h1>AI Assessor</h1>
        <p>
          All feedback from AI marking — questions and practice papers in one
          place.
        </p>
      </div>
    </div>

    {total > 0 && (
      <div className="assessor-header__stats">
        {[
          {
            label: "Total Assessments",
            value: total,
            icon: <Sparkles size={16} />,
            tone: "is-primary",
          },
          {
            label: "Questions Marked",
            value: questionCount,
            icon: <BookOpen size={16} />,
            tone: "is-blue",
          },
          {
            label: "Papers Marked",
            value: paperCount,
            icon: <BarChart2 size={16} />,
            tone: "is-violet",
          },
        ].map((stat) => (
          <div key={stat.label} className="assessor-header__stat">
            <div className={`assessor-header__stat-icon ${stat.tone}`}>
              {stat.icon}
            </div>
            <strong>{stat.value}</strong>
            <span>{stat.label}</span>
          </div>
        ))}
      </div>
    )}
  </header>
)

export default AssessorHeader
